/* eslint-disable jira/filename-case */
/* oxlint-disable typescript/consistent-type-assertions, typescript/no-explicit-any */

type ReactFiberInterestingProperties = {
	elementType: unknown;
	return: ReactFiberInterestingProperties;
	_debugSource?: {
		lineNumber: number;
		columnNumber: number;
		fileName: string;
	};
};

export const getReactFiber = (element: HTMLElement): ReactFiberInterestingProperties | null => {
	const fiberKey = Object.keys(element).find((key) => key.startsWith('__reactFiber'));
	if (!fiberKey) {
		return null;
	}
	return (
		(element as Record<string, any>)[fiberKey] ?? (null as ReactFiberInterestingProperties | null)
	);
};

const getReturnStack = (
	fiber: ReactFiberInterestingProperties,
): ReactFiberInterestingProperties[] => {
	let next = fiber;
	const result = [];
	do {
		result.push(next);
		next = next.return;
	} while (next);
	return result;
};

export const createFiberDebugObject = (
	fiber: ReactFiberInterestingProperties,
): { readonly renderStack: unknown[][] } => {
	return {
		get renderStack(): unknown[][] {
			return getReturnStack(fiber).map(({ _debugSource, elementType }) => {
				let sourceLocation: string;
				if (_debugSource) {
					const { fileName, lineNumber, columnNumber } = _debugSource;
					sourceLocation = `${fileName}:${lineNumber}:${columnNumber}`;
				} else {
					sourceLocation = '(unknown source location)';
				}
				return [sourceLocation, elementType];
			});
		},
	};
};
